module.exports = __webpack_public_path__ + "img/laboratorio_16-9_2880.79602164.jpg";